module.exports = __webpack_public_path__ + "65900b05dc24551906e404711d9a1dcf.png";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/sneaker2.png
// module id = 212
// module chunks = 0